/**
 * This synchronises the pay_method for the fuels when one of them
 * is set to "prepayment_meter"
 * @module embed/pay_method_sync
 */

import { delegate } from '@/lib/events';
import { checkRadio } from '@/lib/forms';

const SELECTOR = '.js-pay-method-sync';
const SELECTOR_TYPES = '.js-pay-method-sync__radio';

const VALUE_SYNCED = 'prepayment_meter';

export default function setupPayMethodSync() {
  document.addEventListener(
    'change',
    delegate(SELECTOR, function(event) {
      delegate(SELECTOR_TYPES, estimationTypeEvent => {
        const value = estimationTypeEvent.target.value;
        maybeSyncFields(value);
      })(event);
    })
  );
}

function maybeSyncFields(value) {
  const radioGroups = Array.from(document.querySelectorAll(SELECTOR_TYPES));
  radioGroups.forEach(function(el) {
    const unknownRadio = el.querySelector(`input[value="${VALUE_SYNCED}"]`);
    if (value == VALUE_SYNCED) {
      checkRadio(unknownRadio);
    } else {
      // Only alter other field if unknown
      if (unknownRadio.checked) {
        checkRadio(el.querySelector(`input[value="${value}"]`));
      }
    }
  });
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/pay_method_sync.js